type instancesType = {
  instanceName: 'th-TH' | 'th-TH-GI' | 'vn-VN' | 'hk-HK-GI' | 'id-ID' | 'vi-VN';
  languages: string[];
};

const instances: instancesType[] = [
  {
    instanceName: 'th-TH',
    languages: ['en', 'th'],
  },
  {
    instanceName: 'th-TH-GI',
    languages: ['en', 'th'],
  },
  {
    instanceName: 'hk-HK-GI',
    languages: ['en', 'zh'],
  },
  {
    instanceName: 'id-ID',
    languages: ['en', 'id'],
  },
  {
    instanceName: 'vi-VN',
    languages: ['en', 'vi'],
  },
];

export default instances;
